
import React from 'react';
import Certificates from '@components/common/Certificate/Certificates';

const WhoWeAre = () => (
    <Certificates
        headingTitle={`Certified Best <span>Web & App Development Company</span><br/> in Surat`}
        headingDescription="It’s not about making loud claims — it’s about delivering real value through every website, app, and digital solution we craft with purpose and precision."
    />
);

export default WhoWeAre;
